export const formatCurrency = (value: number, language: string): string =>
  new Intl.NumberFormat(language.startsWith('en') ? 'en-GB' : 'nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
